import React from 'react';
import { style } from 'typestyle';
import { useTranslation } from 'react-i18next';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import * as cardStyles from './company-card.styles';
import Column from '../../../core/components/column/column.component';
import { CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';

interface Props {
  readonly id: string;
  readonly name: string;
  readonly officeCount: number;
  readonly onClick?: () => void;
}

const CompanyCard = ({
  id,
  name,
  officeCount,
  onClick,
}: Props): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <div
      className={style(cardStyles.cardContainer(onClick !== undefined))}
      key={id}
      onClick={onClick}
      role="presentation"
    >
      <Row
        crossAxisAlignment={CrossAxisAlignment.Center}
        itemSpacing={12}
      >
        <div className={style(cardStyles.iconContainer)}>
          <ApartmentRoundedIcon sx={cardStyles.iconSx} />
        </div>
        <Column>
          <span className={style(cardStyles.nameText)}>
            {name}
          </span>
          <div className={style(cardStyles.chipRow)}>
            <span className={style(cardStyles.chip)}>
              <BusinessRoundedIcon
                sx={cardStyles.chipIconSx}
              />
              {officeCount}{' '}
              {officeCount === 1 ? t('office') : t('offices').toLowerCase()}
            </span>
          </div>
        </Column>
      </Row>
    </div>
  );
};

export default CompanyCard;
